import { Component, OnInit, AfterViewInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { Subject } from 'rxjs';
import { environment } from '@env/environment';
import { WalletService, OrderService } from '@shared/api';
import { ConfirmationProps, ConfirmationComponent } from '../confirmation';
import { Router } from '@angular/router';
import { AddFundsComponent } from '../add-funds/add-funds.component';
import { PrivacyPolicyComponent } from '../privacy-policy/privacy-policy.component';

@Component({
  selector: 'app-order-property-modal',
  templateUrl: './order-property-modal.component.html',
  styleUrls: ['./order-property-modal.component.scss']
})
export class OrderPropertyModalComponent implements OnInit {
  public onClose: Subject<string>;
  public baseUrl = environment.baseUrl;
  details;
  username;
  orderPart: number = 0;
  walletBalance: number = 0;
  orderTotalValue: number = 0;
  notEnoughBallance: boolean = false;
  userConfirm: boolean = false;

  partTimeout;

  transactionDetails;

  constructor(
    private bsModalRef: BsModalRef,
    private modalService: BsModalService,
    private router: Router,
    private _wallet: WalletService,
    private _order: OrderService
  ) {}

  ngOnInit() {
    this.onClose = new Subject();
    const { username } = JSON.parse(localStorage.getItem('currentUser'));
    this.username = username;
    this.getBalance();
  }

  getBalance() {
    if (this.username) {
      this._wallet.getUserWalletBalance(this.username).subscribe(res => {
        this.walletBalance = res.balance;
      });
    }
  }

  changeOrderPart(value) {
    if (this.partTimeout) {
      clearTimeout(this.partTimeout);
    }

    this.partTimeout = setTimeout(() => {
      this._order
        .orderDetails(value, this.username, this.details.propertyId)
        .subscribe(res => {
          this.transactionDetails = res;
          this.orderTotalValue = (res && res.orderTotal) || 0;
          this.notEnoughBallance =
            !(
              !!(this.walletBalance >= this.orderTotalValue) &&
              !!this.orderTotalValue
            ) && !!this.orderPart;
        });
    }, 1500);
  }

  purchasePart() {
    this._order
      .purchaseParts(this.orderPart, this.username, this.details.propertyId)
      .subscribe(() => {
        this.purchaseSuccess();
      });
  }

  purchaseSuccess() {
    this.close('Confirm');
    const props: ConfirmationProps = {
      status: 'success',
      title: 'Your order has been confirmed!',
      desc: `Your part purchase on ${
        this.details.propertyName
      } has been successful.
      You can check your property by going to the My Properties page on the dashboard`,
      buttonLabel: 'More Properties',
      showCancel: true,
      cancelLabel: 'Go to My Properties'
    };
    const modalRef = this.modalService.show(ConfirmationComponent, {
      initialState: { props },
      animated: false,
      class: 'confirmation'
    });
    (<ConfirmationComponent>modalRef.content).onClose.subscribe(result => {
      if (result === 'Ok') {
        this.router.navigate(['/app/properties']);
      } else if (result === 'Cancel') {
        this.router.navigate(['/dashboard/properties']);
      }
    });
  }

  addFund() {
    this.close();
    const modalRef = this.modalService.show(AddFundsComponent, {
      initialState: {},
      animated: false,
      class: 'plaid-modal'
    });
  }

  checkAmount() {
    if (this.orderPart === 0) {
      this.orderPart = null;
    } else if (!this.orderPart) {
      this.orderPart = 0;
    }
  }

  openPolicy() {
    this.modalService.show(PrivacyPolicyComponent, {
      ignoreBackdropClick: false,
      class: 'modal-lg'
    });
  }

  close(response: string = '') {
    this.onClose.next(response);
    this.bsModalRef.hide();
  }
}
